<template>
  <v-dialog v-model="dialog" persistent max-width="740px">
    <v-form enctype="multipart/form-data" ref="form" lazy-validation>
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal -->
        <v-toolbar
          color="secondary"
          dark
          flat
          class="table-header-toolbar px-2 px-sm-4"
        >
          <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
            <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
              <v-icon color="white">{{
                Item.id == 0 ? "mdi-account-plus" : "mdi-account-edit"
              }}</v-icon>
            </div>
            <div class="header-text-block min-width-0 mr-2 mr-sm-3">
              <div class="header-company-title font-weight-bold text-truncate">
                {{ Item.id == 0 ? "Registro de Usuario" : "Editar Usuario" }}
              </div>
            </div>
            <v-chip
              v-if="Item.id > 0"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
            >
              <v-icon left size="15" color="secondary">mdi-pound</v-icon>
              ID: {{ Item.id }}
            </v-chip>
          </div>

          <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
            <v-btn icon dark @click="cerrarDialogo()" class="btn-circle-tooltip">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-toolbar>

        <v-card-text class="pa-3 pa-sm-4 pa-md-5">
          <!-- SECCIÓN 1: DATOS PERSONALES -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-account-details</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Datos Personales y Rol
            </span>
          </div>

          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Nombres *"
                placeholder="Ej. Juan"
                hide-details="auto"
                v-model="Item.nombre"
                outlined
                dense
                prepend-inner-icon="mdi-account"
                class="rounded-lg"
                :rules="requeridos"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Apellidos *"
                placeholder="Ej. Pérez Gómez"
                hide-details="auto"
                v-model="Item.apellidos"
                outlined
                dense
                prepend-inner-icon="mdi-account-outline"
                class="rounded-lg"
                :rules="requeridos"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Teléfono / Celular *"
                placeholder="Ej. 987654321"
                hide-details="auto"
                type="number"
                v-model="Item.telefono"
                outlined
                dense
                prepend-inner-icon="mdi-phone"
                class="rounded-lg"
                :rules="requeridos"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-autocomplete
                v-model="Item.selectedRoles"
                :items="ItemsRoles"
                dense
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-shield-account-outline"
                label="Seleccionar Rol *"
                :rules="requeridos"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- SECCIÓN 2: EMPRESAS AUTORIZADAS -->
          <div class="section-title d-flex align-center mb-3 mt-3">
            <v-icon color="secondary" small class="mr-2">mdi-domain</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Empresas Autorizadas
            </span>
          </div>

          <v-row dense class="mb-2">
            <v-col cols="12" class="pa-2">
              <v-autocomplete
                class="selectAll rounded-lg"
                v-model="Item.selectedEmpresa"
                :items="ItemsEmpresa"
                outlined
                dense
                chips
                deletable-chips
                small-chips
                label="Seleccionar Empresa(s) *"
                prepend-inner-icon="mdi-office-building"
                :rules="requeridos"
                multiple
                hide-details="auto"
              >
                <template v-slot:prepend-item>
                  <v-checkbox
                    :value="allSelected"
                    @change="toggleSelectAll"
                    label="SELECCIONAR TODAS LAS EMPRESAS"
                    class="checkboxSelectedAll"
                    hide-details
                  ></v-checkbox>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <!-- SECCIÓN 3: FIRMA DIGITAL -->
          <div class="section-title d-flex align-center mb-3 mt-3">
            <v-icon color="secondary" small class="mr-2">mdi-draw-pen</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Firma Digital del Usuario (.PNG)
            </span>
          </div>

          <v-row dense class="align-center mb-2">
            <v-col cols="12" sm="7" class="pa-2">
              <v-file-input
                class="imgFirm rounded-lg"
                id="img_firma"
                label="Seleccionar Firma Digital"
                outlined
                dense
                prepend-icon=""
                prepend-inner-icon="mdi-camera"
                accept="image/png, .jpeg, .jpg"
                @change="ObtenerImagen"
                :rules="Item.id > 0 ? [] : requeridos"
                show-size
                truncate-length="25"
                hide-details="auto"
              ></v-file-input>
              <span class="caption text--secondary mt-2 d-block">
                <v-icon x-small color="grey">mdi-information-outline</v-icon>
                Firma manuscrita en formato PNG con fondo transparente.
              </span>
            </v-col>

            <v-col cols="12" sm="5" class="pa-2">
              <div class="signature-preview-box elevation-1 rounded-lg">
                <img
                  id="imagenFirmaPrevio"
                  :src="Item.imagen ? Item.imagen : imagen"
                  alt="firma_previa"
                  class="signature-preview-img"
                />
                <span class="caption text--secondary mt-1 font-weight-medium">
                  Vista Previa Firma
                </span>
              </div>
            </v-col>
          </v-row>

          <!-- SECCIÓN 4: CREDENCIALES DE ACCESO -->
          <div class="section-title d-flex align-center mb-3 mt-3">
            <v-icon color="secondary" small class="mr-2">mdi-lock</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Credenciales de Acceso al Sistema
            </span>
          </div>

          <v-row dense class="mb-1">
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                prepend-inner-icon="mdi-email"
                v-model="Item.email"
                :rules="emailRules"
                name="email"
                label="Correo Electrónico *"
                type="text"
                placeholder="usuario@empresa.com"
                required
                outlined
                dense
                class="rounded-lg"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                v-model="Item.pasword"
                prepend-inner-icon="mdi-lock"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="Item.id > 0 ? [] : [rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                label="Contraseña *"
                placeholder="Mínimo 6 caracteres"
                hint="Al menos 6 caracteres"
                counter
                outlined
                dense
                class="rounded-lg"
                hide-details="auto"
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Botones de Acción / Footer -->
        <v-card-actions class="form-card-actions pa-3 pa-sm-4 bg-light border-top d-flex justify-end align-center">
          <v-btn
            outlined
            color="grey darken-1"
            class="btn-form-action text-capitalize px-4 rounded-lg mr-sm-2 font-weight-medium"
            @click="cerrarDialogo()"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            v-if="Item.id == 0"
            color="primary"
            elevation="1"
            class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
            @click="agregar()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Guardar Usuario
          </v-btn>
          <v-btn
            v-else
            color="primary"
            elevation="1"
            class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
            @click="agregar()"
          >
            <v-icon left small>mdi-pencil</v-icon>
            Actualizar Usuario
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />
  </v-dialog>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex';
import MensajeTransicion from "../Alerta.vue" 

export default {
    props: ['dialog', 'Item'],
    components: {
        MensajeTransicion
    },
    data() {
        return {
            imagenminiatura: '/images/reporte/imagen_no_disponible.jpg',
            emailRules: [
                v => !!v || 'E-mail es requerido',
                v => /.+@.+\..+/.test(v) || 'E-mail no es valido',
            ],
            show1: false,
            rules: {
                required: v => !!v || 'Requerido.',
                min: v => v.length >= 6 || 'Min 6 characters'
            },
            requeridos: [
                v => !!v || 'Este Campo es Requerido.'
            ],
            mensaje: "",
            verAlerta: false
        };
    },
    computed: {
        ...mapState("navigation", ["Permisos"]),
        ...mapGetters('usuario', ['ItemsRoles', 'ItemsEmpresa']),
        imagen() {
            return this.imagenminiatura;
        },

        allSelected() {
            return this.Item.selectedEmpresa.length === this.ItemsEmpresa.length;
        }
    },
    methods: {
        ...mapActions('usuario', ['agregarUsuario']),

        async agregar() {
            if (this.$refs.form.validate()) {
                this.$alertify.confirm(
                    this.Item.id == 0 ? "Realmente desea registra el usuario!" : "¿Realmente desea editar el usuario?",
                    () => {
                        if (this.Item.id == 0) {
                            this.agregarUsuario(this.Item)
                                .then(r => {
                                    this.LimpiarCampos();
                                    this.cerrarDialogo();
                                    this.$alertify.success("Se agrego correctamente el usuario");
                                });
                        } else { 
                            this.agregarUsuario(this.Item)
                            .then(r => {
                                this.LimpiarCampos();
                                this.cerrarDialogo();
                                this.$alertify.success("Se actualizo correctamente el usuario");
                            }); 
                        }
                    }
                ).setHeader('<h3 class="alertTitle">Aviso</h3').set('labels', { ok: 'Aceptar', cancel: 'Cancelar' });
            }
        },

        LimpiarCampos() {
            this.Item.id = 0,
                this.Item.nombre = '',
                this.Item.apellidos = '',
                this.Item.telefono = '',
                this.Item.selectedRoles = '',
                this.Item.selectedEmpresa = [],
                this.Item.imagen_firma = '',
                this.Item.email = '',
                this.Item.pasword = ''
        },

        cerrarDialogo() {
            this.$emit('dialog', false);
        },

        ObtenerImagen() {
            let file = document.getElementById('img_firma').files[0];
            this.Item.imagen_firma = file;
            this.CargarImagen(file)
        },

        CargarImagen(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            }
            reader.readAsDataURL(file)
        },

        toggleSelectAll(value) {
            if (value) {
                this.Item.selectedEmpresa = this.ItemsEmpresa.map(item => item);
            } else {
                this.Item.selectedEmpresa = [];
            }
        },
    }
}
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  overflow: hidden;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.08rem;
  letter-spacing: -0.2px;
}

.header-count-chip {
  font-size: 0.85rem;
  height: 28px;
}

.section-title {
  border-left: 3px solid var(--v-secondary-base, #424242);
  padding-left: 8px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.signature-preview-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  padding: 12px;
  min-height: 110px;
}

.signature-preview-img {
  max-width: 140px;
  max-height: 70px;
  object-fit: contain;
  background: #ffffff;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

.checkboxSelectedAll {
  margin-top: 0px !important;
  padding: 12px 16px !important;
}

.checkboxSelectedAll ::v-deep label {
  font-weight: 700;
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.87) !important;
}

.selectAll ::v-deep .v-select__selections {
  padding: 4px 0px !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.85rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.7rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }

  .signature-preview-box {
    min-height: 90px;
    padding: 8px;
  }

  .signature-preview-img {
    max-width: 120px;
    max-height: 60px;
  }
}
</style>